import PaymentContainerClient from "../../PaymentContainerClient";
import PaymentRequestDto from "../../PaymentContainerClient/dtos/PaymentRequestDto";

export const getPaymentRequest = async (
    token: string
): Promise<PaymentRequestDto> => {
    const paymentContainerClient = new PaymentContainerClient();
    const paymentRequest = await paymentContainerClient.getPaymentRequest(
        token
    );
    return paymentRequest;
};
